
//"status": "ongoing"

export const fetchMenu = {
  "campaign": {
    "minBet": 40,
    "minBetLocal": 76.33,
    "skin": "default",
    "status": "ongoing",
    //  "subscriptionMode": "auto"
    "subscriptionMode": "manual"
  },

  "casino": {
    "category": "social"
  },

  "playerSubscription": {
    "subscribed": true,
  },

  "coinsInfo": [
    {
      "cost": 10,
      "costLocal": 1065,
      "left": 5,
      "was": 10,
      "won": 5
    },
    {
      "cost": 5,
      "costLocal": 532,
      "left": 83,
      "was": 100,
      "won": 17
    },
    {
      "cost": 2,
      "costLocal": 213,
      "left": 387,
      "was": 500,
      "won": 113
    },
    {
      "cost": 1,
      "costLocal": 106,
      "left": 774,
      "was": 1000,
      "won": 226
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0647",
    "playerToCampaignCurrency": "0.939231708462477693246924016"
  },
  "finishDate": 1738256995,
  "playerWinsInfo": [],
  
  "startDate": 1695575389,
  "winsInfo": [
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "MissCherryFruits",
      "playerId": "rq1***",
      "player_id": 700979,
      "player_nickname": "rq1***",
      "time": 1712260424,
      "win": 2
    },


  ]
}

export const fetchMenuAuto = {
  "campaign": {
    "minBet": 66,
    "minBetLocal": 76.33,
    "skin": "default",
    "status": "ongoing",
    "subscriptionMode": "auto"
  },

  "casino": {
    "category": "commercial"
  },

  "playerSubscription": {
    "subscribed": false,
  },

  "coinsInfo": [
    {
      "cost": 10,
      "costLocal": 1065,
      "left": 5,
      "was": 10,
      "won": 5
    },
    {
      "cost": 5,
      "costLocal": 532,
      "left": 83,
      "was": 100,
      "won": 17
    },
    {
      "cost": 2,
      "costLocal": 213,
      "left": 387,
      "was": 500,
      "won": 113
    },
    {
      "cost": 1,
      "costLocal": 106,
      "left": 774,
      "was": 1000,
      "won": 226
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0647",
    "playerToCampaignCurrency": "0.939231708462477693246924016"
  },
  "finishDate": 1738256995,
  "playerWinsInfo": [],
  
  "startDate": 1695575389,
  "winsInfo": [
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "MissCherryFruits",
      "playerId": "rq1***",
      "player_id": 700979,
      "player_nickname": "rq1***",
      "time": 1712260424,
      "win": 2
    },


  ]
}

export const fetchMenuSocial = {
  "campaign": {
    "minBet": 100,
    "minBetLocal": 66.04,
    "skin": "default",
    "status": "ongoing"
  },
  "casino": {
    "category": "social"
  },

  "playerSubscription": {
    "subscribed": true,
  },

  "coinsInfo": [
    {
      "cost": 10,
      "costLocal": 1065,
      "left": 5,
      "was": 10,
      "won": 5
    },
    {
      "cost": 5,
      "costLocal": 532,
      "left": 83,
      "was": 100,
      "won": 17
    },
    {
      "cost": 2,
      "costLocal": 213,
      "left": 387,
      "was": 500,
      "won": 113
    },
    {
      "cost": 1,
      "costLocal": 106,
      "left": 774,
      "was": 1000,
      "won": 226
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0647",
    "playerToCampaignCurrency": "0.939231708462477693246924016"
  },
  "finishDate": 1738256995,
  "playerWinsInfo": [
    {
      "game": "AlchemistBonanza",
      "time": 1710259860,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259842,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259835,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259822,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259815,
      "win": 1,
      "winLocal": 100
    }
  ],
  "startDate": 1695575389,
  "winsInfo": [
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "MissCherryFruits",
      "playerId": "rq1***",
      "player_id": 700979,
      "player_nickname": "rq1***",
      "time": 1712260424,
      "win": 2
    },


  ]
}


export const fetchMenuManual = {
  "campaign": {
    "minBet": 0,
    "minBetLocal": 0,
    "skin": "default",
    "status": "ongoing",
    "subscriptionMode": "manual"

  },
  "playerSubscription": {
    "subscribed": false,
  },

  "coinsInfo": [
    {
      "cost": 10,
      "costLocal": 1065,
      "left": 5,
      "was": 10,
      "won": 5
    },
    {
      "cost": 5,
      "costLocal": 532,
      "left": 83,
      "was": 100,
      "won": 17
    },
    {
      "cost": 2,
      "costLocal": 213,
      "left": 387,
      "was": 500,
      "won": 113
    },
    {
      "cost": 1,
      "costLocal": 106,
      "left": 774,
      "was": 1000,
      "won": 226
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0647",
    "playerToCampaignCurrency": "0.939231708462477693246924016"
  },
  "finishDate": 1738256995,
  "playerWinsInfo": [
    {
      "game": "AlchemistBonanza",
      "time": 1710259860,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259842,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259835,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259822,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259815,
      "win": 1,
      "winLocal": 100
    }
  ],
  "startDate": 1695575389,
  "winsInfo": [
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "MissCherryFruits",
      "playerId": "rq1***",
      "player_id": 700979,
      "player_nickname": "rq1***",
      "time": 1712260424,
      "win": 2
    },


  ]
}


export const fmArchived = {
  "campaign": {
    "skin": "default",
    "status": "archived"
  },
  "coinsInfo": [
    {
      "cost": 1,
      "costLocal": 100,
      "left": 0,
      "was": 5,
      "won": 5
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0",
    "playerToCampaignCurrency": "1.0"
  },
  "finishDate": 1710349647,
  "playerWinsInfo": [
    {
      "game": "AlchemistBonanza",
      "time": 1710259860,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259842,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259835,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259822,
      "win": 1,
      "winLocal": 100
    },
    {
      "game": "AlchemistBonanza",
      "time": 1710259815,
      "win": 1,
      "winLocal": 100
    }
  ],
  "startDate": 1710176843,
  "winsInfo": [
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "AlchemistBonanza",
      "playerId": "Kjy***",
      "player_id": 613967,
      "player_nickname": "Kjy***",
      "time": 1710259860,
      "win": 1
    },
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "AlchemistBonanza",
      "playerId": "Kjy***",
      "player_id": 613967,
      "player_nickname": "Kjy***",
      "time": 1710259842,
      "win": 1
    },
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "AlchemistBonanza",
      "playerId": "Kjy***",
      "player_id": 613967,
      "player_nickname": "Kjy***",
      "time": 1710259835,
      "win": 1
    },
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "AlchemistBonanza",
      "playerId": "Kjy***",
      "player_id": 613967,
      "player_nickname": "Kjy***",
      "time": 1710259822,
      "win": 1
    },
    {
      "countryId": null,
      "countryName": "Unknown",
      "game": "AlchemistBonanza",
      "playerId": "Kjy***",
      "player_id": 613967,
      "player_nickname": "Kjy***",
      "time": 1710259815,
      "win": 1
    }
  ]
}


export const fmSmallCampain = {
  "campaign": {
    "skin": "default",
    "status": "ongoing"
  },
  "coinsInfo": [
    {
      "cost": 1,
      "costLocal": 100,
      "left": 5,
      "was": 5,
      "won": 0
    }
  ],
  "conversionRate": {
    "campaignToPlayerCurrency": "1.0",
    "playerToCampaignCurrency": "1.0"
  },
  "finishDate": 1710348565,
  "playerWinsInfo": [],
  "startDate": 1710175762,
  "winsInfo": []
}
